<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Categories</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Categories
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Categories</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="category-search"
                        placeholder="Search by category name"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="category-status">By Status</label>
                                <select id="category-status" class="form-control form-control-sm" v-model="filters.status">
                                    <option :value="null">All</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="category-parent">By Parent Category</label>
                                <select id="category-parent" class="form-control form-control-sm" v-model="filters.parent_id">
                                    <option :value="null">All</option>
                                    <option value="none">No parent</option>
                                    <option v-for="category in parentCategories" :key="category.id" :value="category.id">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allCategories"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image_url'">
                               <a :href="props.row.image_url" target="_blank">
                                   <img :src="props.row.image_url" :alt="props.row.name +'Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <div v-else-if="props.column.field === 'status'">
                                <template v-if="props.row.status">
                                    <span class="badge badge-glow badge-success">active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">inactive</span>
                                </template>
                            </div>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.categories.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Categories'},
    props: ['categories', 'parentCategories'],
    layout: Layout,
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data: () => ({

        filters: {
            status: null,
            parent_id: null,
        },
        isLoadingFilter: false,
        allCategories: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },

        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Category Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Category Index', field: 'index', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Parent Category', field: 'parent_category', thClass: 'text-center', tdClass: 'text-center'},
            // {label: 'Image', field: 'image_url', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Status', field: 'status', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),

    mounted() {
        this.allCategories = this.categories.data;
        this.totalRecords = this.categories.total
    },

    methods: {
        paginatedData() {
            return this.loadList('admin.categories.index', 'allCategories');
        },
        async deleteCategory(id) {
            this.$inertia.delete(route('admin.categories.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async showAlert(categoryId) {
            const details = {
                title: "Are you sure you want to delete this category?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteCategory(categoryId) : "";
        },
    }
}
</script>
